(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications-service.js');
'use strict';

const {
  jupiter
} = svs.core;


const getplayerCustomizedSettingsAsync = async () => {
  try {
    const options = {
      method: 'GET',
      path: '/player/1/preferences/30'
    };
    const {
      response
    } = await jupiter.callAsync(options);
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      preferences: response === null || response === void 0 ? void 0 : response.preferences
    };
  } catch (err) {
    svs.myProfile.logger.debug('app-notification-service file: getplayerCustomizedSettings error', err);
    return {
      error: err,
      settings: {}
    };
  }
};
const putCustomersProductTogglesAsync = async settings => {
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'PUT',
      path: '/notification/1/playersubscriptions/producttoggles',
      data: settings
    });
    if (status !== 'success') {
      svs.myProfile.logger.warn('PersonalizationSettingsService:setCustomersSettingsAsync error response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.warn(err);
    return {
      status: 'error',
      error: err
    };
  }
};
const getPauseData = async () => {
  try {
    const options = {
      method: 'GET',
      path: '/notification/1/playersubscriptions/sendpause'
    };
    const {
      response
    } = await jupiter.callAsync(options);
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      pauseData: response === null || response === void 0 ? void 0 : response.pauseSendUntil
    };
  } catch (err) {
    svs.myProfile.logger.debug('app-notification-service file: getPauseData error', err);
    return {
      error: err,
      settings: {}
    };
  }
};
const putPauseData = async settings => {
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'PUT',
      path: '/notification/1/playersubscriptions/sendpause',
      data: settings
    });
    if (status !== 'success') {
      svs.myProfile.logger.warn('PersonalizationSettingsService:putPauseData error response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.warn(err);
    return {
      status: 'error',
      error: err
    };
  }
};
const removePauseData = async () => {
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'DELETE',
      path: '/notification/1/playersubscriptions/sendpause'
    });
    if (status !== 'success') {
      svs.myProfile.logger.warn('PersonalizationSettingsService:removePauseData error response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.warn(err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.notifications.appNotifications.appNotificationsService = {
  getplayerCustomizedSettingsAsync,
  putCustomersProductTogglesAsync,
  getPauseData,
  putPauseData,
  removePauseData
};

 })(window);